
var ConfirmFitment = function() {
    'use strict';

    var cf = this;
    cf.productID = false;
    cf.vehicleConfigID = false;
    cf.fitmentConfirmed = false;
    cf.modalShown = false;
    cf.addToCartFunction = window.addToCart;

    cf.$modal = $( '.js-confirm-fitment-modal' );
    cf.$body = cf.$modal.find( '.modal-body' );
    cf.$vehicleSelector = cf.$modal.find( '.js-confirm-fitment-vehicle-selector' )
    cf.$loading = cf.$modal.find( '.js-loading' );
    cf.$results = cf.$modal.find( '.js-fitment-results' );
    cf.$addToCart = cf.$modal.find( '.js-add-to-cart' );
    cf.$skip = cf.$modal.find( '.js-skip' );

    cf._init = function() {

        // slice() to copy these arrays values, otherwise we have
        // race conditions of multiple things trying to modify it
        var selectedSteps = [];
        if (   window.selectedFitsVehicleSteps
            && window.selectedFitsVehicleSteps.length
            ) {
            selectedSteps = window.selectedFitsVehicleSteps.slice();
        }
        else if( window.selectedChatVehicleSteps
              && window.selectedChatVehicleSteps.length
            ) {
            selectedSteps = window.selectedChatVehicleSteps.slice();
        }

        cf.vehicleSelector = new VehicleSelectorV2(
            cf.$vehicleSelector,
            selectedSteps
        );
        cf.vehicleSelector
            .onHasNoSelectedVehicle(      function()       { cf.setVehicleConfigID( false ) } )
            .onHasPartialVehicleSelected( function()       { cf.setVehicleConfigID( false ) } )
            .onVehicleSelected(           function( vcID ) { cf.setVehicleConfigID( vcID  ) } )
            .init( true );

        cf.$addToCart.click( function() {
            cf.addToCart();
        } );

        cf.$skip.click( function() {
            cf.fitmentConfirmed = true;
            cf.addToCart();
        } );
    };
    
    cf.setVehicleConfigID = function( vcID ) {
        window.selectedVehicleConfigID = vcID;
        cf.vehicleConfigID = vcID;
        cf.checkFitment();
    };

    cf.setProductID = function( productID ) {
        cf.productID = productID;

        var productHasAppDesc = window.productHasAppDesc || {};
        var hasAppDesc = productHasAppDesc[ productID ];
        if ( ! hasAppDesc ) {
            cf.confirmFitment();
            cf.modalShown = true;
            return false;
        }
        else if ( cf.productID != productID ) {
            cf.fitmentConfirmed = false;
            cf.modalShown = false;
        }
        cf.checkFitment();
        return true;
    };

    cf.show = function() {
        cf.modalShown = true;
        if ( cf.vehicleConfigID ) {
            // do not show modal if vehicle already selected
            cf.fitmentConfirmed = true;
            cf.addToCart();
        }
        else {
            cf.$modal.modal( 'show' );
        }
    };

    cf.loading = function( enable ) {
        if ( enable ) {
            cf.$loading.removeClass( 'hide' );
        }
        else {
            cf.$loading.addClass( 'hide' );
        }
    };

    cf.checkFitment = function() {
        var failure = function( err ) {
            console.log( 'Failed to check fitment', err );
            // if the fitment service is down, let them add it to their cart
            cf.confirmFitment();
        };

        // don't bother checking if we don't have the data
        if(    ! cf.productID
            || ! cf.vehicleConfigID
            ) {
            cf.fitmentConfirmed = false;
            cf.hideResults();
            return false;
        }

        cf.loading( true );
        $.ajax( {
            'url'      : '/DoesThisFit/',
            'type'     : 'GET',
            'dataType' : 'json',
            'data'     : {
                'pID'        : cf.productID,
                'vID'        : cf.vehicleConfigID,
                'setSession' : 1,
            },
        } )
        .done( function( data ) {
            if ( ! data.success ) return failure( data.errMsg );

            cf.showResults( data );
        } )
        .fail( failure )
        .always( function() {
            cf.loading( false );
        } );
    };

    cf.showResults = function( data ) {
        cf.$results.parent().removeClass( 'hide' );
        cf.$results.removeClass( 'noFit maybeFit yesFit' );

        if ( ! data.fitsVehicle ) {
            cf.$results.addClass( 'noFit' );
            cf.$results.html( 'Does NOT fit your ' + data.vehicleLabel );
        }
        else if ( data.appDesc ) {
            cf.$results.addClass( 'maybeFit' );
            cf.$results.html( data.appDesc );
        }
        else {
            cf.$results.addClass( 'yesFit' );
            cf.$results.html( 'Fits your ' + data.vehicleLabel );
        }

        cf.confirmFitment();
    };

    cf.hideResults = function() {
        cf.$results.parent().addClass( 'hide' );
        cf.$addToCart.addClass( 'disabled' );
        cf.$addToCart.attr( 'disabled', true );
    };

    cf.confirmFitment = function( ) {
        cf.$addToCart.removeClass( 'disabled' );
        cf.$addToCart.removeAttr( 'disabled' );
        cf.fitmentConfirmed = true;
    };

    cf.addToCart = function() {
        if (   cf.fitmentConfirmed
            && cf.modalShown
            ) {
            cf.addToCartFunction( cf.productID );
        }
    };

    cf._init();
};

